module.exports = __webpack_public_path__ + "f2d88057a33088e93e1c1dfd569acda5.gif";